import "./App.css";
import { AllCards } from "./components/AllCards";

function App() {
    return (
        <>
            <h1 style={{textAlign: 'center', color: 'white'}}>Cards UI</h1>
            <AllCards />
        </>
    );
}

export default App;
